/** Rút gọn nhãn lựa chọn: bỏ số đầu dòng và nội dung trong ngoặc */
export function getOptionDisplayLabel(text: any): string {
  if (typeof text !== 'string' || !text) return '';
  let cleaned = text.replace(/^\d+\.\s*/, '');
  cleaned = cleaned.replace(/\s*\([^)]*\)/g, '');
  cleaned = cleaned.replace(/^[A-Z]\.\s*/i, '');
  return cleaned.trim();
}